import { render, staticRenderFns } from "./ELPanel.vue?vue&type=template&id=4b721688&scoped=true"
import script from "./ELPanel.vue?vue&type=script&lang=js"
export * from "./ELPanel.vue?vue&type=script&lang=js"
import style0 from "./ELPanel.vue?vue&type=style&index=0&id=4b721688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b721688",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
